/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Student_NoteInputs */

const en_student_note = /** @type {(inputs: Student_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Note`)
};

const he_student_note = /** @type {(inputs: Student_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הערה`)
};

/**
* | output |
* | --- |
* | "Note" |
*
* @param {Student_NoteInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const student_note = /** @type {((inputs?: Student_NoteInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Student_NoteInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_student_note(inputs)
	return he_student_note(inputs)
});